import React, {memo} from "react";
import styles from "./index.module.scss";

function ProgressBar({uploadProgress}) {
  return (
    <>
      {!!uploadProgress && (
        <div className={styles.progress_bar_container}>
          <div className={styles.progress_bar} style={{width: uploadProgress}} />
        </div>
      )}
    </>
  );
}

export default memo(ProgressBar);
